import {Component} from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { UserAccountApi } from '../../../theme/services/sdk';

import {GlobalState} from '../../../global.state';

@Component({
  selector: 'ba-page-top',
  templateUrl: 'baPageTop.html',
  styleUrls: ['baPageTop.scss'],
  providers: [UserAccountApi]
})
export class BaPageTop {

  public isScrolled:boolean = false;
  public isMenuCollapsed:boolean = false;

  constructor(
      private _state:GlobalState,
      private route: ActivatedRoute,
      private router: Router,
      protected user:UserAccountApi) {
    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });
  }

  public toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
    return false;
  }

  public scrolledChanged(isScrolled) {
    this.isScrolled = isScrolled;
  }

  onLogout(event) {
    event.stopPropagation();
    this.user.logout().subscribe(() => {
      this.router.navigate(['login']);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/components/baPageTop/baPageTop.component.ts